import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { ToastContainer } from "react-toastify";
import api from "../../../../../features/auth/axiosConfig";
import EditMenu from "../../EditMenu";
import DeleteConfirmation, { DeleteConfirmationHandle } from "./DeleteConfirmation";
import RoleSelect from "../../RoleSelect";
import LoadingScreen from "../../../../components/LoadingScreen";
import { filters } from "../utils/userOperations";
import { menu, handleAddCardClick } from "../utils/userHelpers";
import { UserContent, UserEmployeeData } from "../EditUser/component/types";
import { handleCheckboxToggle } from "../utils/useHandlers";
import UserTable from "./UserTable";
import { handleSearch } from "../utils/useSearchValidation";
import CommonButtons from "src/shared/components/CommonButtons";
import { useUserTheme } from "src/shared/utils/useUserTheme";
import { PageTitle } from "src/shared/PageTitle";
import EmployeeModal from "src/business-types/grocery/layouts/setting/employee/AddEmployee";
import { EmployeeInterface } from "src/shared/services/interface";

function User() {
  const [employeeData, setEmployeeData] = useState<UserEmployeeData[]>([]);
  const [, setUserContent] = useState<UserContent[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filteredData, setFilteredData] = useState<UserEmployeeData[]>([]);
  const [isEditMode, setIsEditMode] = useState<EmployeeInterface | null>(null);
  const [showDeletedUsers, setShowDeletedUsers] = useState<boolean>(false);
  const [selectedUserId, setSelectedUserId] = useState<string>("");
  // const [rowsPerPage, setRowsPerPage] = useState(5);
  const [, setPage] = useState(0);
  const [showRoleSelect, setShowRoleSelect] = useState(false);
  const [isBranchSelected, setIsBranchSelected] = useState(false);
  const [, setBusinessType] = useState<string>("");
  const [isLoading,] = useState<boolean>(false);
  const [, setIsCheckboxClicked] = useState(false);
  const deleteModalRef = useRef<DeleteConfirmationHandle>(null);
  const [employee, setEmployee] = useState<boolean>(false)

  const { fontClass, borderHighlight } = useUserTheme();

  // Refresh user data
  const refreshUserData = () => {
    filters(showDeletedUsers, api, setUserContent, setEmployeeData, setFilteredData);
  };

  useEffect(() => {
    const storedBusinessType = sessionStorage.getItem("business_type");
    setBusinessType(String(storedBusinessType));
  }, []);

  useEffect(() => {
    document.title = "Users › Settings › iMetanic";
    refreshUserData();
  }, []);

  const handleAddCard = (id: string) => {
    handleAddCardClick(id, setSelectedUserId, setShowRoleSelect, setIsBranchSelected);
  };

  const handleEdit = (id: string) => {
    if (id) {
      const editId: EmployeeInterface | undefined = filteredData.filter((i) => i._id.$oid === id)[0]
      if (editId) {
        setIsEditMode(editId)
        setEmployee(true)
      }
    }

  };

  const handleCheckboxClick = () => {
    handleCheckboxToggle(showDeletedUsers, setShowDeletedUsers, setIsCheckboxClicked, setSearchTerm, (value: boolean) => {
      filters(value, api, setUserContent, setEmployeeData, setFilteredData);
    });
  };

  // const isDefaultHeader = ["Laundry", "Vechicle retailer", "Saloon", "Carwash"].includes(businessType);

  const handleDeleteUserClick = (id: string | number, username: string) => {
    deleteModalRef.current?.openModal(id, username);
  };

  const handleRoleSelectClose = () => {
    setShowRoleSelect(false);
    setSelectedUserId("");
    setIsBranchSelected(false);
  };

  return (
    <div>
      <div className="flex flex-col w-[88vw] h-[88vh] items-center overflow-hidden">
        <PageTitle title="- Settings › User" />
        <EditMenu editmenu={menu} />
        <div className="customer-toolbar flex items-center justify-end gap-4 p-2">
          <div className="user-toolbar">
            <div className="flex items-center" id="view-deleted-users">
              <FormControlLabel control={<Checkbox />} onClick={handleCheckboxClick} label="View deleted users" id="deleted-users-checkbox" />
            </div>
            <div className="user-search-input-wrap">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => handleSearch(e, employeeData, setFilteredData, setSearchTerm, setPage)}
                placeholder="Search by Name or Phone number"
                className={`w-full px-3 py-2.5 border rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`}
              />
            </div>
            <div className="add-user-btn">
              <CommonButtons className="w-44 h-10" label="ADD USER" onClick={() => setEmployee(true)} />
            </div>
          </div>
        </div>
        <UserTable
          filteredData={filteredData}
          onEditUser={handleEdit}
          onAddCardClick={handleAddCard}
          isBranchSelected={isBranchSelected}
          onDeleteClick={handleDeleteUserClick}
          showDeletedUsers={showDeletedUsers}
        />
      </div>

      <EmployeeModal onClose={() => { setEmployee(false); setIsEditMode(null); }} open={employee} editData={isEditMode} onSuccess={refreshUserData} />



      <DeleteConfirmation ref={deleteModalRef} />
      {showRoleSelect && <RoleSelect id={selectedUserId} onClose={handleRoleSelectClose} />}
      {/* </div> */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnHover />
      {isLoading && <LoadingScreen />}
    </div>
  );
}

export default User;